<template>
  <div class="footer" :class="{ concise: concise }">
    <div class="container">
      <p class="org-phone">咨询老师：{{ phone }}</p>
      <p>
        Copyright © 2019 远健卓实教育科技（北京）有限公司. All rights reserved.
        京ICP备19042936号-2
      </p>
    </div>
  </div>
</template>

<script>
import { setOrgInfo } from "@/utils/org.js";
export default {
  name: "Footer",
  props: {
    concise: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      phone: ""
    };
  },
  created() {
    setOrgInfo(r => {
      this.phone = r.phone;
    });
  }
};
</script>
<style scoped lang="scss">
@import "../../assets/style/var.scss";
.footer {
  width: 100%;
  background-color: #fff;
  height: $--footer-height;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  &.concise {
    background: transparent;
    .org-phone {
      display: none !important;
    }
  }
  .container {
    width: $--container-width;
    margin: 0 auto;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .org-phone {
      color: #333333;
      font-size: 16px;
      margin-bottom: 10px;
    }
    p {
      margin: 0;
      font-size: 14px;
      color: #868691;
    }
  }
}
</style>
